import { render, staticRenderFns } from "./NorticSelectShowItemContent.vue?vue&type=template&id=02585ff5&scoped=true&"
import script from "./NorticSelectShowItemContent.vue?vue&type=script&lang=js&"
export * from "./NorticSelectShowItemContent.vue?vue&type=script&lang=js&"
import style0 from "./NorticSelectShowItemContent.vue?vue&type=style&index=0&id=02585ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02585ff5",
  null
  
)

export default component.exports